import { render, staticRenderFns } from "./RequestCardDuplicatePage.vue?vue&type=template&id=431b50b2&scoped=true"
import script from "./RequestCardDuplicatePage.vue?vue&type=script&lang=js"
export * from "./RequestCardDuplicatePage.vue?vue&type=script&lang=js"
import style0 from "./RequestCardDuplicatePage.vue?vue&type=style&index=0&id=431b50b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b50b2",
  null
  
)

export default component.exports